export default "__VITE_ASSET__80f8ae4e__"